(() => {
  const initialized = new WeakSet();
  const initialURL = new URL(window.location.href);
  const oldPage = Number(initialURL.searchParams.get('page'));
  // Old bookmarked pagination must not land on an empty native 250-record batch.
  if (oldPage > 1 && document.getElementById('ProductGridContainer')?.dataset.iglamNativePages === '1') {
    initialURL.searchParams.delete('page');
    initialURL.hash = 'iglam-page-' + oldPage;
    window.location.replace(initialURL.href);
    return;
  }
  let requestedPage = Number(initialURL.hash.match(/^#iglam-page-(\d+)$/)?.[1]) || 1;

  function initialize(grid) {
    if (initialized.has(grid)) return;
    const nav = grid.parentElement.querySelector('[data-iglam-grouped-pagination]');
    if (!nav) return;
    initialized.add(grid);
    const cards = Array.from(grid.children);
    const size = Math.max(1, Number(grid.dataset.pageSize) || 36);
    const pages = Math.ceil(cards.length / size);
    const initialPage = requestedPage;
    requestedPage = 1;
    if (pages <= 1) return;
    const list = nav.querySelector('ul');
    let current = 1;

    function show(page, moveFocus) {
      current = Math.max(1, Math.min(pages, page));
      grid.dataset.groupedPage = String(current);
      const url = new URL(window.location.href);
      if (current > 1) url.hash = 'iglam-page-' + current;
      else if (/^#iglam-page-\d+$/.test(url.hash)) url.hash = '';
      window.history.replaceState(window.history.state, '', url.href);
      cards.forEach((card, index) => {
        card.hidden = index < (current - 1) * size || index >= current * size;
      });
      list.replaceChildren();
      const addButton = (label, target, ariaLabel, active = false) => {
        const li = document.createElement('li');
        li.className = 'page-item';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pagination__item page-link' + (active ? ' active' : '');
        button.textContent = label;
        button.dataset.page = String(target);
        button.setAttribute('aria-label', ariaLabel);
        if (active) button.setAttribute('aria-current', 'page');
        li.append(button);
        list.append(li);
      };
      if (current > 1) addButton('‹', current - 1, 'Previous page');
      for (let pageNumber = 1; pageNumber <= pages; pageNumber++) {
        addButton(String(pageNumber), pageNumber, 'Page ' + pageNumber, pageNumber === current);
      }
      if (current < pages) addButton('›', current + 1, 'Next page');
      nav.hidden = false;
      if (moveFocus) {
        grid.setAttribute('tabindex', '-1');
        grid.focus({ preventScroll: true });
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    nav.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-page]');
      if (button && nav.contains(button)) show(Number(button.dataset.page), true);
    });
    show(initialPage, false);
  }

  function scan() {
    document.querySelectorAll('[data-iglam-grouped-grid]').forEach(initialize);
  }
  scan();
  // Shopify facets replace the grid after each filter/sort change: initialize its new cards.
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
